import React from 'react'
import Link from '@material-ui/core/Link'
import { navigate } from 'gatsby'

export default function LinkLink({ noUnderline, ...props }) {
  return <Link {...props} onClick={e => { e.preventDefault(); navigate(props.href) }} 
      style={{textDecoration: (noUnderline ? "none" : "underline")}}>{props.children}</Link>
}